import { reactive, createApp } from 'vue';
// import Vue from "vue";
import App from './App.vue';
import router from "./router/router";

const app = createApp(App);

app.use(router);


// Vue.config.productionTip = false;

// Create reactive data store
const store = reactive({
    sliderImgsArr: [
        "living_room_01.jpg",
        "living_room_02.jpg",
        "living_room_03.jpg",
        "kitchen_01.jpg",
        "kitchen_02.jpg",
        "kitchen_03.jpg",
        "bed_room_01.jpg",
        "bath_room_01.jpg",
        "bath_room_02.jpg",
        "office_room_01.jpg",
        "wardrobes_01.png",
        "wardrobes_02.png",
    ],
    // fullGalleryImgsArr: [
    //     "pro_0001_pic_0001.jpg",
    //     "pro_0001_pic_0002.jpg",
    //     "pro_0001_pic_0003.jpg",
    //     "pro_0001_pic_0004.jpg",
    //     "pro_0001_pic_0005.jpg",
    //     "pro_0001_pic_0006.jpg",
    //     "pro_0001_pic_0007.jpg",
    //     "pro_0001_pic_0008.jpg",
    //     "pro_0001_pic_0009.jpg",
    //     "pro_0001_pic_0010.jpg",
    //     "pro_0001_pic_0011.jpg",
    //     "pro_0001_pic_0012.jpg",
    //     "pro_0001_pic_0013.jpg",
    //     "pro_0002_pic_0001.jpg",
    //     "pro_0002_pic_0002.jpg",
    //     "pro_0002_pic_0003.jpg",
    //     "pro_0002_pic_0004.jpg",
    //     "pro_0002_pic_0005.jpg",
    //     "pro_0002_pic_0006.jpg",
    //     "pro_0002_pic_0007.jpg",
    //     "pro_0002_pic_0008.jpg",
    //     "pro_0002_pic_0009.jpg",
    //     "pro_0002_pic_0010.jpg",
    //     "pro_0002_pic_0011.jpg",
    //     "pro_0002_pic_0012.jpg",
    //     "pro_0002_pic_0013.jpg",
    //     "pro_0002_pic_0014.jpg",
    //     "pro_0002_pic_0015.jpg",
    //     "pro_0002_pic_0016.jpg",
    //     "pro_0002_pic_0017.jpg",
    //     "pro_0002_pic_0018.jpg",
    //     "pro_0003_pic_0001.jpg",
    //     "pro_0003_pic_0002.jpg",
    //     "pro_0003_pic_0003.jpg",
    //     "pro_0003_pic_0004.jpg",
    //     "pro_0003_pic_0005.jpg",
    //     "pro_0003_pic_0006.jpg",
    //     "pro_0003_pic_0007.jpg",
    //     "pro_0003_pic_0008.jpg",
    //     "pro_0003_pic_0009.jpg",
    //     "pro_0003_pic_0010.jpg",
    //     "pro_0003_pic_0011.jpg",
    //     "pro_0004_pic_0001.jpg",
    //     "pro_0004_pic_0002.jpg",
    //     "pro_0004_pic_0003.jpg",
    //     "pro_0004_pic_0004.jpg",
    //     "pro_0004_pic_0005.png",
    //     "pro_0004_pic_0006.jpg",
    //     "pro_0004_pic_0007.png",
    //     "pro_0004_pic_0008.png",
    //     "pro_0004_pic_0009.png",
    //     "pro_0004_pic_0010.png",
    // ],
    testGalleryImgsArr: [
        "pro_0001_pic_0001.jpg",
        "pro_0001_pic_0002.jpg",
        "pro_0001_pic_0003.jpg",
        "pro_0001_pic_0004.jpg",
        "pro_0001_pic_0005.jpg",
        "pro_0001_pic_0006.jpg",
        "pro_0001_pic_0007.jpg",
        "pro_0001_pic_0008.jpg",
        "pro_0001_pic_0009.jpg",
        "pro_0001_pic_0010.jpg",
        "pro_0001_pic_0011.jpg",
        "pro_0001_pic_0012.jpg",
        "pro_0001_pic_0013.jpg",
    ],

    fullGalleryImgInfo: [
        { project_number: 1, pics_number: 16 },
        { project_number: 2, pics_number: 110 },
        { project_number: 3, pics_number: 63 },
        { project_number: 4, pics_number: 8 },
        { project_number: 5, pics_number: 76 },
        { project_number: 6, pics_number: 18 },
        { project_number: 7, pics_number: 6 },
        { project_number: 8, pics_number: 50 },
        { project_number: 9, pics_number: 13 },
        { project_number: 10, pics_number: 24 },
        { project_number: 11, pics_number: 5 },
        { project_number: 12, pics_number: 26 },
        { project_number: 13, pics_number: 27 },
        { project_number: 14, pics_number: 10 },
        { project_number: 15, pics_number: 3 },
        { project_number: 16, pics_number: 12 },
        { project_number: 17, pics_number: 14 },
        { project_number: 18, pics_number: 5 },
        { project_number: 19, pics_number: 8 },
        { project_number: 20, pics_number: 5 },
        { project_number: 21, pics_number: 2 },
        { project_number: 22, pics_number: 1 },
        { project_number: 23, pics_number: 4 },
    ],

    fullGalleryImgsObj: {},

    // fullGalleryImgsObj: {
    //     pro_0001: [
    //         "pro_0001_pic_0001.jpg",
    //         "pro_0001_pic_0002.jpg",
    //         "pro_0001_pic_0003.jpg",
    //         "pro_0001_pic_0004.jpg",
    //         "pro_0001_pic_0005.jpg",
    //         "pro_0001_pic_0006.jpg",
    //         "pro_0001_pic_0007.jpg",
    //         "pro_0001_pic_0008.jpg",
    //         "pro_0001_pic_0009.jpg",
    //         "pro_0001_pic_0010.jpg",
    //         "pro_0001_pic_0011.jpg",
    //         "pro_0001_pic_0012.jpg",
    //         "pro_0001_pic_0013.jpg",
    //         "pro_0001_pic_0014.jpg",
    //         "pro_0001_pic_0015.jpg",
    //         "pro_0001_pic_0016.jpg",
    //     ],
    //     pro_0002: [
    //         "pro_0002_pic_0001.jpg",
    //         "pro_0002_pic_0002.jpg",
    //         "pro_0002_pic_0003.jpg",
    //         "pro_0002_pic_0004.jpg",
    //         "pro_0002_pic_0005.jpg",
    //         "pro_0002_pic_0006.jpg",
    //         "pro_0002_pic_0007.jpg",
    //         "pro_0002_pic_0008.jpg",
    //         "pro_0002_pic_0009.jpg",
    //         "pro_0002_pic_0010.jpg",
    //         "pro_0002_pic_0011.jpg",
    //         "pro_0002_pic_0012.jpg",
    //         "pro_0002_pic_0013.jpg",
    //         "pro_0002_pic_0014.jpg",
    //         "pro_0002_pic_0015.jpg",
    //         "pro_0002_pic_0016.jpg",
    //         "pro_0002_pic_0017.jpg",
    //         "pro_0002_pic_0018.jpg",
    //         "pro_0002_pic_0019.jpg",
    //         "pro_0002_pic_0020.jpg",
    //         "pro_0002_pic_0021.jpg",
    //         "pro_0002_pic_0022.jpg",
    //         "pro_0002_pic_0023.jpg",
    //         "pro_0002_pic_0024.jpg",
    //         "pro_0002_pic_0025.jpg",
    //         "pro_0002_pic_0026.jpg",
    //         "pro_0002_pic_0027.jpg",
    //         "pro_0002_pic_0028.jpg",
    //         "pro_0002_pic_0029.jpg",
    //         "pro_0002_pic_0030.jpg",
    //         "pro_0002_pic_0031.jpg",
    //         "pro_0002_pic_0032.jpg",
    //         "pro_0002_pic_0033.jpg",
    //         "pro_0002_pic_0034.jpg",
    //         "pro_0002_pic_0035.jpg",
    //         "pro_0002_pic_0036.jpg",
    //         "pro_0002_pic_0037.jpg",
    //         "pro_0002_pic_0038.jpg",
    //         "pro_0002_pic_0039.jpg",
    //         "pro_0002_pic_0040.jpg",
    //         "pro_0002_pic_0041.jpg",
    //         "pro_0002_pic_0042.jpg",
    //         "pro_0002_pic_0043.jpg",
    //         "pro_0002_pic_0044.jpg",
    //         "pro_0002_pic_0045.jpg",
    //         "pro_0002_pic_0046.jpg",
    //         "pro_0002_pic_0047.jpg",
    //         "pro_0002_pic_0048.jpg",
    //         "pro_0002_pic_0049.jpg",
    //         "pro_0002_pic_0050.jpg",
    //         "pro_0002_pic_0051.jpg",
    //         "pro_0002_pic_0052.jpg",
    //         "pro_0002_pic_0053.jpg",
    //         "pro_0002_pic_0054.jpg",
    //         "pro_0002_pic_0055.jpg",
    //         "pro_0002_pic_0056.jpg",
    //         "pro_0002_pic_0057.jpg",
    //         "pro_0002_pic_0058.jpg",
    //         "pro_0002_pic_0059.jpg",
    //         "pro_0002_pic_0060.jpg",
    //         "pro_0002_pic_0061.jpg",
    //         "pro_0002_pic_0062.jpg",
    //         "pro_0002_pic_0063.jpg",
    //         "pro_0002_pic_0064.jpg",
    //         "pro_0002_pic_0065.jpg",
    //         "pro_0002_pic_0066.jpg",
    //         "pro_0002_pic_0067.jpg",
    //         "pro_0002_pic_0068.jpg",
    //         "pro_0002_pic_0069.jpg",
    //         "pro_0002_pic_0070.jpg",
    //         "pro_0002_pic_0071.jpg",
    //         "pro_0002_pic_0072.jpg",
    //         "pro_0002_pic_0073.jpg",
    //         "pro_0002_pic_0074.jpg",
    //         "pro_0002_pic_0075.jpg",
    //         "pro_0002_pic_0076.jpg",
    //         "pro_0002_pic_0077.jpg",
    //         "pro_0002_pic_0078.jpg",
    //         "pro_0002_pic_0079.jpg",
    //         "pro_0002_pic_0080.jpg",
    //         "pro_0002_pic_0081.jpg",
    //         "pro_0002_pic_0082.jpg",
    //         "pro_0002_pic_0083.jpg",
    //         "pro_0002_pic_0084.jpg",
    //         "pro_0002_pic_0085.jpg",
    //         "pro_0002_pic_0086.jpg",
    //         "pro_0002_pic_0087.jpg",
    //         "pro_0002_pic_0088.jpg",
    //         "pro_0002_pic_0089.jpg",
    //         "pro_0002_pic_0090.jpg",
    //         "pro_0002_pic_0091.jpg",
    //         "pro_0002_pic_0092.jpg",
    //         "pro_0002_pic_0093.jpg",
    //         "pro_0002_pic_0094.jpg",
    //         "pro_0002_pic_0095.jpg",
    //         "pro_0002_pic_0096.jpg",
    //         "pro_0002_pic_0097.jpg",
    //         "pro_0002_pic_0098.jpg",
    //         "pro_0002_pic_0099.jpg",
    //         "pro_0002_pic_0100.jpg",
    //         "pro_0002_pic_0101.jpg",
    //         "pro_0002_pic_0102.jpg",
    //         "pro_0002_pic_0103.jpg",
    //         "pro_0002_pic_0104.jpg",
    //         "pro_0002_pic_0105.jpg",
    //         "pro_0002_pic_0106.jpg",
    //         "pro_0002_pic_0107.jpg",
    //         "pro_0002_pic_0108.jpg",
    //         "pro_0002_pic_0109.jpg",
    //         "pro_0002_pic_0110.jpg",
    //     ],
    //     pro_0003: [
    //         "pro_0003_pic_0001.jpg",
    //         "pro_0003_pic_0002.jpg",
    //         "pro_0003_pic_0003.jpg",
    //         "pro_0003_pic_0004.jpg",
    //         "pro_0003_pic_0005.jpg",
    //         "pro_0003_pic_0006.jpg",
    //         "pro_0003_pic_0007.jpg",
    //         "pro_0003_pic_0008.jpg",
    //         "pro_0003_pic_0009.jpg",
    //         "pro_0003_pic_0010.jpg",
    //         "pro_0003_pic_0011.jpg",
    //         "pro_0003_pic_0012.jpg",
    //         "pro_0003_pic_0013.jpg",
    //         "pro_0003_pic_0014.jpg",
    //         "pro_0003_pic_0015.jpg",
    //         "pro_0003_pic_0016.jpg",
    //         "pro_0003_pic_0017.jpg",
    //         "pro_0003_pic_0018.jpg",
    //         "pro_0003_pic_0019.jpg",
    //         "pro_0003_pic_0020.jpg",
    //         "pro_0003_pic_0021.jpg",
    //         "pro_0003_pic_0022.jpg",
    //         "pro_0003_pic_0023.jpg",
    //         "pro_0003_pic_0024.jpg",
    //         "pro_0003_pic_0025.jpg",
    //         "pro_0003_pic_0026.jpg",
    //         "pro_0003_pic_0027.jpg",
    //         "pro_0003_pic_0028.jpg",
    //         "pro_0003_pic_0029.jpg",
    //         "pro_0003_pic_0030.jpg",
    //         "pro_0003_pic_0031.jpg",
    //         "pro_0003_pic_0032.jpg",
    //         "pro_0003_pic_0033.jpg",
    //         "pro_0003_pic_0034.jpg",
    //         "pro_0003_pic_0035.jpg",
    //         "pro_0003_pic_0036.jpg",
    //         "pro_0003_pic_0037.jpg",
    //         "pro_0003_pic_0038.jpg",
    //         "pro_0003_pic_0039.jpg",
    //         "pro_0003_pic_0040.jpg",
    //         "pro_0003_pic_0041.jpg",
    //         "pro_0003_pic_0042.jpg",
    //         "pro_0003_pic_0043.jpg",
    //         "pro_0003_pic_0044.jpg",
    //         "pro_0003_pic_0045.jpg",
    //         "pro_0003_pic_0046.jpg",
    //         "pro_0003_pic_0047.jpg",
    //         "pro_0003_pic_0048.jpg",
    //         "pro_0003_pic_0049.jpg",
    //         "pro_0003_pic_0050.jpg",
    //         "pro_0003_pic_0051.jpg",
    //         "pro_0003_pic_0052.jpg",
    //         "pro_0003_pic_0053.jpg",
    //         "pro_0003_pic_0054.jpg",
    //         "pro_0003_pic_0055.jpg",
    //         "pro_0003_pic_0056.jpg",
    //         "pro_0003_pic_0057.jpg",
    //         "pro_0003_pic_0058.jpg",
    //         "pro_0003_pic_0059.jpg",
    //         "pro_0003_pic_0060.jpg",
    //         "pro_0003_pic_0061.jpg",
    //         "pro_0003_pic_0062.jpg",
    //         "pro_0003_pic_0063.jpg",
    //     ],
    //     pro_0004: [
    //         "pro_0004_pic_0001.jpg",
    //         "pro_0004_pic_0002.jpg",
    //         "pro_0004_pic_0003.jpg",
    //         "pro_0004_pic_0004.jpg",
    //         "pro_0004_pic_0005.jpg",
    //         "pro_0004_pic_0006.jpg",
    //         "pro_0004_pic_0007.jpg",
    //         "pro_0004_pic_0008.jpg",
    //     ],
    //     pro_0005: [
    //         "pro_0005_pic_0001.jpg",
    //         "pro_0005_pic_0002.jpg",
    //         "pro_0005_pic_0003.jpg",
    //         "pro_0005_pic_0004.jpg",
    //         "pro_0005_pic_0005.jpg",
    //         "pro_0005_pic_0006.jpg",
    //         "pro_0005_pic_0007.jpg",
    //         "pro_0005_pic_0008.jpg",
    //         "pro_0005_pic_0009.jpg",
    //         "pro_0005_pic_0010.jpg",
    //         "pro_0005_pic_0011.jpg",
    //         "pro_0005_pic_0012.jpg",
    //         "pro_0005_pic_0013.jpg",
    //         "pro_0005_pic_0014.jpg",
    //         "pro_0005_pic_0015.jpg",
    //         "pro_0005_pic_0016.jpg",
    //         "pro_0005_pic_0017.jpg",
    //         "pro_0005_pic_0018.jpg",
    //         "pro_0005_pic_0019.jpg",
    //         "pro_0005_pic_0020.jpg",
    //         "pro_0005_pic_0021.jpg",
    //         "pro_0005_pic_0022.jpg",
    //         "pro_0005_pic_0023.jpg",
    //         "pro_0005_pic_0024.jpg",
    //         "pro_0005_pic_0025.jpg",
    //         "pro_0005_pic_0026.jpg",
    //         "pro_0005_pic_0027.jpg",
    //         "pro_0005_pic_0028.jpg",
    //         "pro_0005_pic_0029.jpg",
    //         "pro_0005_pic_0030.jpg",
    //         "pro_0005_pic_0031.jpg",
    //         "pro_0005_pic_0032.jpg",
    //         "pro_0005_pic_0033.jpg",
    //         "pro_0005_pic_0034.jpg",
    //         "pro_0005_pic_0035.jpg",
    //         "pro_0005_pic_0036.jpg",
    //         "pro_0005_pic_0037.jpg",
    //         "pro_0005_pic_0038.jpg",
    //         "pro_0005_pic_0039.jpg",
    //         "pro_0005_pic_0040.jpg",
    //         "pro_0005_pic_0041.jpg",
    //         "pro_0005_pic_0042.jpg",
    //         "pro_0005_pic_0043.jpg",
    //         "pro_0005_pic_0044.jpg",
    //         "pro_0005_pic_0045.jpg",
    //         "pro_0005_pic_0046.jpg",
    //         "pro_0005_pic_0047.jpg",
    //         "pro_0005_pic_0048.jpg",
    //         "pro_0005_pic_0049.jpg",
    //         "pro_0005_pic_0050.jpg",
    //         "pro_0005_pic_0051.jpg",
    //         "pro_0005_pic_0052.jpg",
    //         "pro_0005_pic_0053.jpg",
    //         "pro_0005_pic_0054.jpg",
    //         "pro_0005_pic_0055.jpg",
    //         "pro_0005_pic_0056.jpg",
    //         "pro_0005_pic_0057.jpg",
    //         "pro_0005_pic_0058.jpg",
    //         "pro_0005_pic_0059.jpg",
    //         "pro_0005_pic_0060.jpg",
    //         "pro_0005_pic_0061.jpg",
    //         "pro_0005_pic_0062.jpg",
    //         "pro_0005_pic_0063.jpg",
    //         "pro_0005_pic_0064.jpg",
    //         "pro_0005_pic_0065.jpg",
    //         "pro_0005_pic_0066.jpg",
    //         "pro_0005_pic_0067.jpg",
    //         "pro_0005_pic_0068.jpg",
    //         "pro_0005_pic_0069.jpg",
    //         "pro_0005_pic_0070.jpg",
    //         "pro_0005_pic_0071.jpg",
    //         "pro_0005_pic_0072.jpg",
    //         "pro_0005_pic_0073.jpg",
    //         "pro_0005_pic_0074.jpg",
    //         "pro_0005_pic_0075.jpg",
    //         "pro_0005_pic_0076.jpg",
    //     ],
    //     pro_0006: [
    //         "pro_0006_pic_0001.jpg",
    //         "pro_0006_pic_0002.jpg",
    //         "pro_0006_pic_0003.jpg",
    //         "pro_0006_pic_0004.jpg",
    //         "pro_0006_pic_0005.jpg",
    //         "pro_0006_pic_0006.jpg",
    //         "pro_0006_pic_0007.jpg",
    //         "pro_0006_pic_0008.jpg",
    //         "pro_0006_pic_0009.jpg",
    //         "pro_0006_pic_0010.jpg",
    //         "pro_0006_pic_0011.jpg",
    //         "pro_0006_pic_0012.jpg",
    //         "pro_0006_pic_0013.jpg",
    //         "pro_0006_pic_0014.jpg",
    //         "pro_0006_pic_0015.jpg",
    //         "pro_0006_pic_0016.jpg",
    //         "pro_0006_pic_0017.jpg",
    //         "pro_0006_pic_0018.jpg",
    //     ],
    //     pro_0007: [
    //         "pro_0007_pic_0001.jpg",
    //         "pro_0007_pic_0002.jpg",
    //         "pro_0007_pic_0003.jpg",
    //         "pro_0007_pic_0004.jpg",
    //         "pro_0007_pic_0005.jpg",
    //         "pro_0007_pic_0006.jpg",
    //     ],
    //     pro_0008: [
    //         "pro_0008_pic_0001.jpg",
    //         "pro_0008_pic_0002.jpg",
    //         "pro_0008_pic_0003.jpg",
    //         "pro_0008_pic_0004.jpg",
    //         "pro_0008_pic_0005.jpg",
    //         "pro_0008_pic_0006.jpg",
    //         "pro_0008_pic_0007.jpg",
    //         "pro_0008_pic_0008.jpg",
    //         "pro_0008_pic_0009.jpg",
    //         "pro_0008_pic_0010.jpg",
    //         "pro_0008_pic_0011.jpg",
    //         "pro_0008_pic_0012.jpg",
    //         "pro_0008_pic_0013.jpg",
    //         "pro_0008_pic_0014.jpg",
    //         "pro_0008_pic_0015.jpg",
    //         "pro_0008_pic_0016.jpg",
    //         "pro_0008_pic_0017.jpg",
    //         "pro_0008_pic_0018.jpg",
    //         "pro_0008_pic_0019.jpg",
    //         "pro_0008_pic_0020.jpg",
    //         "pro_0008_pic_0021.jpg",
    //         "pro_0008_pic_0022.jpg",
    //         "pro_0008_pic_0023.jpg",
    //         "pro_0008_pic_0024.jpg",
    //         "pro_0008_pic_0025.jpg",
    //         "pro_0008_pic_0026.jpg",
    //         "pro_0008_pic_0027.jpg",
    //         "pro_0008_pic_0028.jpg",
    //         "pro_0008_pic_0029.jpg",
    //         "pro_0008_pic_0030.jpg",
    //         "pro_0008_pic_0031.jpg",
    //         "pro_0008_pic_0032.jpg",
    //         "pro_0008_pic_0033.jpg",
    //         "pro_0008_pic_0034.jpg",
    //         "pro_0008_pic_0035.jpg",
    //         "pro_0008_pic_0036.jpg",
    //         "pro_0008_pic_0037.jpg",
    //         "pro_0008_pic_0038.jpg",
    //         "pro_0008_pic_0039.jpg",
    //         "pro_0008_pic_0040.jpg",
    //         "pro_0008_pic_0041.jpg",
    //         "pro_0008_pic_0042.jpg",
    //         "pro_0008_pic_0043.jpg",
    //         "pro_0008_pic_0044.jpg",
    //         "pro_0008_pic_0045.jpg",
    //         "pro_0008_pic_0046.jpg",
    //         "pro_0008_pic_0047.jpg",
    //         "pro_0008_pic_0048.jpg",
    //         "pro_0008_pic_0049.jpg",
    //         "pro_0008_pic_0050.jpg",
    //     ],
    //     pro_0009: [
    //         "pro_0009_pic_0001.jpg",
    //         "pro_0009_pic_0002.jpg",
    //         "pro_0009_pic_0003.jpg",
    //         "pro_0009_pic_0004.jpg",
    //         "pro_0009_pic_0005.jpg",
    //         "pro_0009_pic_0006.jpg",
    //         "pro_0009_pic_0007.jpg",
    //         "pro_0009_pic_0008.jpg",
    //         "pro_0009_pic_0009.jpg",
    //         "pro_0009_pic_0010.jpg",
    //         "pro_0009_pic_0011.jpg",
    //         "pro_0009_pic_0012.jpg",
    //         "pro_0009_pic_0013.jpg",
    //     ],
    //     pro_0010: [
    //         "pro_0010_pic_0001.jpg",
    //         "pro_0010_pic_0002.jpg",
    //         "pro_0010_pic_0003.jpg",
    //         "pro_0010_pic_0004.jpg",
    //         "pro_0010_pic_0005.jpg",
    //         "pro_0010_pic_0006.jpg",
    //         "pro_0010_pic_0007.jpg",
    //         "pro_0010_pic_0008.jpg",
    //         "pro_0010_pic_0009.jpg",
    //         "pro_0010_pic_0010.jpg",
    //         "pro_0010_pic_0011.jpg",
    //         "pro_0010_pic_0012.jpg",
    //         "pro_0010_pic_0013.jpg",
    //         "pro_0010_pic_0014.jpg",
    //         "pro_0010_pic_0015.jpg",
    //         "pro_0010_pic_0016.jpg",
    //         "pro_0010_pic_0017.jpg",
    //         "pro_0010_pic_0018.jpg",
    //         "pro_0010_pic_0019.jpg",
    //         "pro_0010_pic_0020.jpg",
    //         "pro_0010_pic_0021.jpg",
    //         "pro_0010_pic_0022.jpg",
    //         "pro_0010_pic_0023.jpg",
    //         "pro_0010_pic_0024.jpg",
    //     ],
    //     pro_0011: [
    //         "pro_0011_pic_0001.jpg",
    //         "pro_0011_pic_0002.jpg",
    //         "pro_0011_pic_0003.jpg",
    //         "pro_0011_pic_0004.jpg",
    //         "pro_0011_pic_0005.jpg",
    //     ],
    //     pro_0012: [
    //         "pro_0012_pic_0001.jpg",
    //         "pro_0012_pic_0002.jpg",
    //         "pro_0012_pic_0003.jpg",
    //         "pro_0012_pic_0004.jpg",
    //         "pro_0012_pic_0005.jpg",
    //         "pro_0012_pic_0006.jpg",
    //         "pro_0012_pic_0007.jpg",
    //         "pro_0012_pic_0008.jpg",
    //         "pro_0012_pic_0009.jpg",
    //         "pro_0012_pic_0010.jpg",
    //         "pro_0012_pic_0011.jpg",
    //         "pro_0012_pic_0012.jpg",
    //         "pro_0012_pic_0013.jpg",
    //         "pro_0012_pic_0014.jpg",
    //         "pro_0012_pic_0015.jpg",
    //         "pro_0012_pic_0016.jpg",
    //         "pro_0012_pic_0017.jpg",
    //         "pro_0012_pic_0018.jpg",
    //         "pro_0012_pic_0019.jpg",
    //         "pro_0012_pic_0020.jpg",
    //         "pro_0012_pic_0021.jpg",
    //         "pro_0012_pic_0022.jpg",
    //         "pro_0012_pic_0023.jpg",
    //         "pro_0012_pic_0024.jpg",
    //         "pro_0012_pic_0025.jpg",
    //         "pro_0012_pic_0026.jpg",
    //     ],
    //     pro_0013: [
    //         "pro_0013_pic_0001.jpg",
    //         "pro_0013_pic_0002.jpg",
    //         "pro_0013_pic_0003.jpg",
    //         "pro_0013_pic_0004.jpg",
    //         "pro_0013_pic_0005.jpg",
    //         "pro_0013_pic_0006.jpg",
    //         "pro_0013_pic_0007.jpg",
    //         "pro_0013_pic_0008.jpg",
    //         "pro_0013_pic_0009.jpg",
    //         "pro_0013_pic_0010.jpg",
    //         "pro_0013_pic_0011.jpg",
    //         "pro_0013_pic_0012.jpg",
    //         "pro_0013_pic_0013.jpg",
    //         "pro_0013_pic_0014.jpg",
    //         "pro_0013_pic_0015.jpg",
    //         "pro_0013_pic_0016.jpg",
    //         "pro_0013_pic_0017.jpg",
    //         "pro_0013_pic_0018.jpg",
    //         "pro_0013_pic_0019.jpg",
    //         "pro_0013_pic_0020.jpg",
    //         "pro_0013_pic_0021.jpg",
    //         "pro_0013_pic_0022.jpg",
    //         "pro_0013_pic_0023.jpg",
    //         "pro_0013_pic_0024.jpg",
    //         "pro_0013_pic_0025.jpg",
    //         "pro_0013_pic_0026.jpg",
    //         "pro_0013_pic_0027.jpg",
    //     ],
    //     pro_0014: [
    //         "pro_0014_pic_0001.jpg",
    //         "pro_0014_pic_0002.jpg",
    //         "pro_0014_pic_0003.jpg",
    //         "pro_0014_pic_0004.jpg",
    //         "pro_0014_pic_0005.jpg",
    //         "pro_0014_pic_0006.jpg",
    //         "pro_0014_pic_0007.jpg",
    //         "pro_0014_pic_0008.jpg",
    //         "pro_0014_pic_0009.jpg",
    //         "pro_0014_pic_0010.jpg",
    //     ],
    //     pro_0015: [
    //         "pro_0015_pic_0001.jpg",
    //         "pro_0015_pic_0002.jpg",
    //         "pro_0015_pic_0003.jpg",
    //     ],
    //     pro_0016: [
    //         "pro_0016_pic_0001.jpg",
    //         "pro_0016_pic_0002.jpg",
    //         "pro_0016_pic_0003.jpg",
    //         "pro_0016_pic_0004.jpg",
    //         "pro_0016_pic_0005.jpg",
    //         "pro_0016_pic_0006.jpg",
    //         "pro_0016_pic_0007.jpg",
    //         "pro_0016_pic_0008.jpg",
    //         "pro_0016_pic_0009.jpg",
    //         "pro_0016_pic_0010.jpg",
    //         "pro_0016_pic_0011.jpg",
    //         "pro_0016_pic_0012.jpg",
    //     ],
    //     pro_0017: [
    //         "pro_0017_pic_0001.jpg",
    //         "pro_0017_pic_0002.jpg",
    //         "pro_0017_pic_0003.jpg",
    //         "pro_0017_pic_0004.jpg",
    //         "pro_0017_pic_0005.jpg",
    //         "pro_0017_pic_0006.jpg",
    //         "pro_0017_pic_0007.jpg",
    //         "pro_0017_pic_0008.jpg",
    //         "pro_0017_pic_0009.jpg",
    //         "pro_0017_pic_0010.jpg",
    //         "pro_0017_pic_0011.jpg",
    //         "pro_0017_pic_0012.jpg",
    //         "pro_0017_pic_0013.jpg",
    //         "pro_0017_pic_0014.jpg",
    //     ],
    //     pro_0018: [
    //         "pro_0018_pic_0001.jpg",
    //         "pro_0018_pic_0002.jpg",
    //         "pro_0018_pic_0003.jpg",
    //         "pro_0018_pic_0004.jpg",
    //         "pro_0018_pic_0005.jpg",
    //     ],
    //     pro_0019: [
    //         "pro_0019_pic_0001.jpg",
    //         "pro_0019_pic_0002.jpg",
    //         "pro_0019_pic_0003.jpg",
    //         "pro_0019_pic_0004.jpg",
    //         "pro_0019_pic_0005.jpg",
    //         "pro_0019_pic_0006.jpg",
    //         "pro_0019_pic_0007.jpg",
    //         "pro_0019_pic_0008.jpg",
    //     ],
    //     pro_0020: [
    //         "pro_0020_pic_0001.jpg",
    //         "pro_0020_pic_0002.jpg",
    //         "pro_0020_pic_0003.jpg",
    //         "pro_0020_pic_0004.jpg",
    //         "pro_0020_pic_0005.jpg",
    //     ],
    //     pro_0021: [
    //         "pro_0021_pic_0001.jpg",
    //         "pro_0021_pic_0002.jpg",
    //     ],
    //     pro_0022: [
    //         "pro_0022_pic_0001.jpg",
    //     ],
    //     pro_0023: [
    //         "pro_0023_pic_0001.jpg",
    //         "pro_0023_pic_0002.jpg",
    //         "pro_0023_pic_0003.jpg",
    //         "pro_0023_pic_0004.jpg",
    //     ],
    // }

    // generateFullGalleryImgsArr(infoArray) {
    //     const pad = (num, size) => String(num).padStart(size, '0');
    //     const result = {};
      
    //     infoArray.forEach(({ project_number, pics_number }) => {
    //       const projectKey = `pro_${pad(project_number, 4)}`;
    //       const picsArray = [];
      
    //       for (let i = 1; i <= pics_number; i++) {
    //         const picFilename = `${projectKey}_pic_${pad(i, 4)}.jpg`;
    //         picsArray.push(picFilename);
    //       }
      
    //       result[projectKey] = picsArray;
    //     });
      
    //     return result;
    // },

    generateFullGalleryImgsObj(infoArray) {
        const pad = (num, size) => String(num).padStart(size, '0');
        const result = {};
      
        infoArray.forEach(({ project_number, pics_number }) => {
          const projectKey = `pro_${pad(project_number, 4)}`;
          const images = [];
      
          for (let i = 1; i <= pics_number; i++) {
            const imageName = `${projectKey}_pic_${pad(i, 4)}.jpg`;
            images.push(imageName);
          }
      
          result[projectKey] = images;
        });
      
        return result;
      }
      
      

});

// Make the store globally available
app.config.globalProperties.$store = store;

app.mount('#app');

// createApp(App).use(router).mount('#app');